var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import prodA from './data/products/productA.json';
import prodB from './data/products/productB.json';
import prodC from './data/products/productC.json';
import { SchemaName } from '@cewe-onsitesearch/schemas';
import { MockdataSearchProviderConfig } from './MockdataSearchProviderConfig';
export class MockdataSearchProvider {
    /**
     *
     * @param config
     */
    constructor(config = new MockdataSearchProviderConfig()) {
        this.config = config;
    }
    search(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = {
                request: {
                    query: query,
                    params: {},
                    suggestions: {},
                    keyAccount: 6822,
                },
                alternatives: [],
                results: {},
            };
            if (query.match(/foto/i)) {
                response.results[SchemaName.product] = { queryID: '', hits: [] };
                response.results[SchemaName.product].hits.push(prodB);
                response.results[SchemaName.product].hits.push(prodC);
                response.results[SchemaName.product].hits.push(prodA);
                response.results[SchemaName.product].hits.push(prodA);
                response.results[SchemaName.product].hits.push(prodA);
                response.results[SchemaName.product].hits.push(prodA);
                response.results[SchemaName.product].hits.push(prodA);
            }
            return response;
        });
    }
    isReady() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.config.isReady;
        });
    }
    trackResultItemClick() {
        return __awaiter(this, void 0, void 0, function* () {
            return true;
        });
    }
    getDynamicContentByQuery(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = {
                request: {
                    query: query,
                    params: {},
                    keyAccount: 6822,
                    country: 'DE',
                    language: 'de',
                },
                results: {},
            };
            response.results[SchemaName.product] = { queryID: '', hits: [] };
            response.results[SchemaName.product].hits.push(prodB);
            return response;
        });
    }
}
